import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {PrimeNgModule} from '@app/shared/modules/prime-ng/prime-ng.module';
import {EffectsModule} from '@ngrx/effects';
import {SharedModule} from '../shared/shared.module';
import {NewOrderComponent} from './components/new-order/new-order.component';
import {ProductVariantComponent} from './components/product-variant/product-variant.component';
import {NewOrderEffects} from './state/new-order.effects';

@NgModule({
  imports: [
    RouterModule,
    FormsModule,
    SharedModule,
    PrimeNgModule,
    EffectsModule.forFeature([NewOrderEffects]),
    NewOrderComponent,
    ProductVariantComponent,
  ],
})
export class ProductModule {}
